import TableToolbar from '@rio-cloud/rio-uikit/TableToolbar';
import TableViewToggles, { type TableViewTogglesViewType } from '@rio-cloud/rio-uikit/TableViewToggles';
import TableSearch from '@rio-cloud/rio-uikit/TableSearch';
import TableSettingsDialog from '@rio-cloud/rio-uikit/TableSettingsDialog';
import Button from '@rio-cloud/rio-uikit/Button';
import { Tag } from '@rio-cloud/rio-uikit';
import { ColumnDetailsMap } from '../../../shared/models/ColumnDetailsMap';
import { ColumnDetails } from '../../../shared/models/ColumnDetails';
import { ColumnLabel } from '../../../shared/models/ColumnLabel';
import { SelectedVehicle } from '../../../shared/models/SelectedVehicle';

type DashboardTableToolbarProps = {
  searchValue: string;
  onSearchChange: (value: string) => void;
  viewType: TableViewTogglesViewType;
  onViewTypeChange: (newViewType: TableViewTogglesViewType) => void;
  selectedVehicle: SelectedVehicle;
  onToggleSettings: () => void;
  showTableSettingsDialog: boolean;
  onHideSettings: () => void;
  onColumnChange: (newColumnOrder: string[], newHiddenColumns: string[], newColumnsDetails?: ColumnDetailsMap) => void;
  onColumnDetailsChange: (column: string, newColumnDetails: ColumnDetails) => void;
  columnOrder: string[];
  hiddenColumns: string[];
  columnsDetails: ColumnDetailsMap;
  columnLabels: ColumnLabel;
  bestPracticesColumnOrder: string[];
  disabledColumns: string[];
  asset: any;
  hasData: boolean;
};

const DashboardTableToolbar = (props: DashboardTableToolbarProps) => {
  const {
    searchValue,
    onSearchChange,
    viewType,
    onViewTypeChange,
    selectedVehicle,
    onToggleSettings,
    showTableSettingsDialog,
    onHideSettings,
    onColumnChange,
    onColumnDetailsChange,
    columnOrder,
    hiddenColumns,
    columnsDetails,
    columnLabels,
    bestPracticesColumnOrder,
    disabledColumns,
    asset,
    hasData
  } = props;


  if (!hasData) return null;

  return (
    <TableToolbar>
      <div className='table-toolbar-container'>
        <div className='table-toolbar-group-left'>
          <div className='table-toolbar-column table-toolbar-column-spacer'>
            <TableSearch value={searchValue} onChange={onSearchChange} placeholder='Buscar' />
          </div>
          <div className='margin-left-10'>
            <Tag round={false} icon='rioglyph-truck text-size-14'>
              {asset.name}
            </Tag>
          </div>
          <div className='margin-left-10'> 
            <Tag className='text-size-14' round={false}>Chassi: {asset.identification}</Tag>
          </div>
        </div>
        <div className='table-toolbar-group-right'>
          <div className='table-toolbar-column'></div>
          <div style={{ display: 'inline' }} className='btn-group table-toolbar-column table-toolbar-column-spacer'>
            <Button iconOnly iconName='rioglyph-cog' onClick={onToggleSettings} />
          </div>
          <div className='table-toolbar-column'>
            <TableViewToggles
              initialViewType={viewType}
              onViewTypeChange={onViewTypeChange}
              tableViewTooltipContent='Table view'
              singleCardViewTooltipContent='List view'
              multiCardsViewTooltipContent='Cards view'
            />
          </div>
        </div>
        {showTableSettingsDialog && (
          <TableSettingsDialog
            show={showTableSettingsDialog}
            title='Table settings'
            onHide={onHideSettings}
            onColumnChange={onColumnChange}
            defaultColumnOrder={bestPracticesColumnOrder}
            defaultHiddenColumns={[]}
            columnOrder={columnOrder}
            hiddenColumns={hiddenColumns}
            columnLabels={columnLabels}
            disabledColumns={disabledColumns}
            closeButtonText='Close'
            resetButtonText='Reset to default'
            searchPlaceholder='Search by column name'
            notFoundMessage='No column found for this search value'
            columnsDetails={columnsDetails}
            autoLabel='Auto'
            onColumnDetailsChange={onColumnDetailsChange}
            onSearchChange={() => {}}
            immediateChange
          />
        )}
      </div>
    </TableToolbar>
  );
};

export default DashboardTableToolbar;